var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",class:[_vm.skinClasses],attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),(_vm.fab_status)?_c('c-support-box',{attrs:{"id":_vm.id,"param-ubah":_vm.paramUbah}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }